<template>
  <div>
    <div class="banner">
      <el-image src="https://sritrang.oss-cn-shanghai.aliyuncs.com/202108/2021082503080930.jpg"></el-image>
      <div class="cover">
        <h1>诗董中国</h1>
        <div class="subtitle">关于诗董</div>
      </div>
    </div>

    <div class="box">
      <el-row>
        <el-col :span="6">
          <div class="img8">
            <el-image src="/img/c111.jpg"></el-image>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="tbox">
            <h1>诗董中国</h1>
            <p class="intro-text">
              诗董中国目前在国内的橡胶和手套业务分别由上海诗董贸易有限公司和诗董医疗器械（上海）有限公司负责。
            </p>
            <p class="intro-text">
              上海诗董贸易有限公司于2004年成立，是诗董集团在中国设立的全资子公司。公司经营全范围覆盖了标胶、复合胶、烟片胶、乳胶等集团下属工厂的各类橡胶产品。2018年诗董在中国市场天然橡胶销售量达到80万吨，占中国本地市场份额近15%，在所有天然橡胶供应商和出口商中排名领先。
            </p>
            <p class="intro-text">
              诗董医疗器械（上海）有限公司是诗董集团在中国设立的全资子公司，全面负责集团在华手套业务的开展。诗董手套于2012年登临中国市场，强势的品牌、优质的产品，集合集团近30载的海外行销经验，并兼顾本地市场特点，诗董手套迅速打开市场，在国内的医疗、口腔、工业、科研领域达成广泛应用，业务网络逐步深入各个区域，获得客户的高度认可。
            </p>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index"
}
</script>

<style scoped>
@import url("Index.css");
</style>
